import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import i18n from 'i18next';
import { ToggleButtonGroup } from 'ziphy-web-shared/basic/lib/forms/fields';
import { useDefinitionSelectItems } from 'ziphy-web-shared/basic/lib/forms/fields/select/Select.hooks';
import { getToggleButtonGroupProps } from '../';
import styles from './ToggleButtonForm.module.scss';
import ToggleButtonPlain from './ToggleButtonPlain';
const ToggleButtonForm = ({ $element }) => {
    const { config, renderType, field } = $element;
    const blocked = useMemo(() => {
        return typeof field.primaryValue === 'object'
            ? Object.entries(field.primaryValue)
                .map(([key, value]) => (value.blocked ? key : undefined))
                .filter((item) => typeof item === 'string')
            : [];
    }, [config.subvariant, field.primaryValue]);
    const { fieldProps } = useMemo(() => getToggleButtonGroupProps($element, blocked), [config, blocked]);
    const selectIdOptions = useDefinitionSelectItems(config.selectId, {
        extraField: { element: 'input', placeholder: i18n.t('label.text_here') },
        blocked: blocked.length > 0 ? blocked : undefined,
    });
    const items = (selectIdOptions === null || selectIdOptions === void 0 ? void 0 : selectIdOptions.length) ? selectIdOptions : config.options || [];
    if (renderType === 'plain') {
        return _jsx(ToggleButtonPlain, { withText: true, field: field, items: items });
    }
    return (_jsx(ToggleButtonGroup, Object.assign({ field: field, options: items }, fieldProps, { className: styles.toggleButtonGroup, connectedGroupClassName: styles.group })));
};
export default observer(ToggleButtonForm);
